/**
 * Cloudinary URL helpers — single source of truth (SSOT).
 * Framework-agnostic (no Nuxt/Vue deps): importable by the SaaS via the
 * `@shared` alias AND by the standalone widget vite build via relative path.
 */

/**
 * Normalise a Cloudinary brand-logo URL. The backend serves vehicle logos with
 * a `c_thumb,w_80,g_face` transformation (gravity "face"): a logo has no face
 * to detect, so Cloudinary replies 400 and the `<img>` fails to load. We
 * rewrite the transformation block to `c_fit`: the whole logo fits in the box,
 * no crop and no face detection.
 *
 * - Cloudinary URL with transform → transform replaced by `c_fit,w_,h_`
 * - Cloudinary URL without transform → `c_fit` injected (the `v123…` version segment is preserved)
 * - non-Cloudinary / empty URL → returned verbatim
 */
export function normalizeBrandLogo(url: string | null | undefined, size = 80): string {
  if (!url) return ''
  const s = String(url).trim()
  if (!s.includes('res.cloudinary.com') || !s.includes('/upload/')) return s
  // The transform block is the segment right after /upload/ starting with
  // params (`c_`, `w_`, `g_`…). `v1624617985` (version) starts with v+digit so
  // it is never mistaken for a transform and stays intact.
  return s.replace(/\/upload\/(?:[a-z]{1,3}_[^/]*\/)?/, `/upload/c_fit,w_${size},h_${size}/`)
}
